import React from "react";
import { cn } from "@RHCommerceDev/utils/cn";
import { useEnv } from "@RHCommerceDev/hooks/useEnv";
import yn from "yn";

const RHRSearchIconV2 = ({
  className,
  strokeWidth = 0.75,
  ...restProps
}: React.ComponentProps<"svg">) => {
  const env = useEnv();
  const FEATURE_NEW_HEADER = yn(env?.FEATURE_NEW_HEADER);

  return FEATURE_NEW_HEADER ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-black", className)}
      {...restProps}
    >
      <circle
        cx="11.5004"
        cy="10.8793"
        r="7.1762"
        stroke="currentColor"
        stroke-width={strokeWidth}
      />
      <line
        x1="16.5699"
        y1="16.1098"
        x2="21.917"
        y2="21.457"
        stroke="currentColor"
        stroke-width={strokeWidth}
      />
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-black", className)}
      {...restProps}
    >
      <circle
        cx="11.5004"
        cy="9.87932"
        r="7.1762"
        stroke="currentColor"
        stroke-width={strokeWidth}
      />
      <line
        x1="16.5699"
        y1="15.1098"
        x2="21.917"
        y2="20.457"
        stroke="currentColor"
        stroke-width={strokeWidth}
      />
    </svg>
  );
};

export default RHRSearchIconV2;
